export const RedoIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0)'>
        <path d='M12 8L14 6L12 4' stroke='currentColor' />
        <path
          d='M13.4995 6C11.2314 6 9.95722 6.38122 8.8883 7.09545C7.81938 7.80968 6.98626 8.82484 6.49429 10.0126C6.00232 11.2003 5.8736 12.5072 6.12441 13.7681C6.37521 15.029 6.99428 16.1872 7.90332 17.0962C8.81236 18.0052 9.97055 18.6243 11.2314 18.8751C12.4923 19.1259 13.7992 18.9972 14.987 18.5052C16.1747 18.0132 17.1898 17.1801 17.9041 16.1112C18.6183 15.0423 18.9995 13.7856 18.9995 12.5'
          stroke='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='white' transform='translate(24 24) rotate(-180)' />
        </clipPath>
      </defs>
    </svg>
  )
}
